export default  {
  bindings: {
    discount: '=',
    title: '@',
    formTab: '='
  },
  controller: 'discountSaveController',
  template: require('../views/discount.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/components/discount.save.component.js